<template>
  <!-- FOOTER 
  =============================================-->
  <section>
    <div class="clear"></div>
    <div class="row ft-reponsive">
      <div class="col-lg-3 col-md-3 col-5" style="text-align: center; ">
        <img
          :src="getApiPath('0efd425b-2ac4-49d6-bc97-2f90ae250093.jpg')"
          alt="All about winter"
          style="margin-right: 20px;"
        />
      </div>

      <div class="col-lg-3 col-md-3 col-7">
        <div class="fancy-title title-border">
          <h4>ALL about winter</h4>
        </div>
        <p class="responsive-ft-font">
          พบกับเราได้ที่สาขาใหญ่หน้าร้าน
          <br />Line id  :  @all_aboutwinter <br />Call  :  097-086-6681<br />
          เปิดบริการ  11.30 – 20.30<br />
          จองออนไลน์ตลอด  24  ชั่วโมง<br />
        </p>
      </div>

      <div class="col-lg-6 col-md-6 col-12">
        <div class="fancy-title title-border">
          <h4>Connect with Us</h4>
        </div>
        <div class="row " style="padding-top:20px; width:100%; margin-left:auto; margin-right:auto;">
          <div class="social_banner col-lg-3 col-md-2 col-2"></div>
          
          <div class="social_banner col-lg-2 col-md-2 col-2">
            <img
              :src="getFullPath('fb_logo.png')"
              style="cursor:pointer; border-radius:10px;"
              @click="
                redirectToExternal(
                  'https://www.facebook.com/All.about.winter2022'
                )
              "
            />
          </div>

          <div class="social_banner col-lg-2 col-md-2 col-2">
            <img
              :src="getFullPath('ig_logo.png')"
              style="cursor:pointer;; border-radius:10px;"
              @click="
                redirectToExternal(
                  'https://www.instagram.com/all_about_winter/?igsh=eG5pY3lldHphYjBs'
                )
              "
            />
          </div>
          <div class="social_banner col-lg-2 col-md-2 col-2">
            <img
              :src="getFullPath('line_logo.png')"
              style="cursor:pointer;  border-radius:10px;"
              @click="redirectToExternal(' https://line.me/R/ti/p/@ikw0685b?oat_content=url')"
            />
          </div>

        </div>
      </div>
    </div>
  </section>
  <!-- row -->
</template>
<script>
import store from "@/store.js";
import myMixins from "@/mixins/myMixins.js";
export default {
  mixins: [myMixins],
  data() {
    return {};
  },
  methods: {
    getFullPath(mainImage) {
      if (mainImage === undefined || mainImage === null || mainImage === "") {
        return store.state.imageUrl + "defaultimage.png";
      } else {
        return store.state.imageUrl + mainImage;
      }
    },
  },
  components: {},
};
</script>

<style>
.ft-reponsive {
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 90px;
  padding-bottom: 40px;
}
@media only screen and (max-width: 800px) {
  .ft-reponsive {
    margin-left: auto;
    margin-right: auto;
    margin-top: 0 !important;
    padding-bottom: 40px;
    margin-bottom: 220px !important;
  }
  .responsive-ft-font {
    font-size: 0.6rem !important;
  }
  .fancy-title {
    position: relative;
    margin-bottom: 10px !important;
    margin-top: 10px !important;
    font-size: 0.8rem !important;
  }
}
</style>